import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import withEhsPageBehavior from '../../withEhsPageBehavior';
import { history } from '../../state/store';

import Button from '../form/Button';
import Message from '../form/Message';

import Subnav from '../subnav';
import PracticeApi from '../../api/practice';

class NewOrganizationPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            errorMessage: null,
            isbusy: false,
            name: '',
            primary_practice: false,
            abbreviation: '',
        };

        this.onChange = this.onChange.bind(this);
        this.savePractice = this.savePractice.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    validateForm() {
        if (!this.state.name) {
            return 'Please enter a name for the practice.';
        }
        return null;
    }

    onChange(evt) {
        let changes = {};
        changes[evt.target.name] = evt.target.value;
        this.setState(changes);
    }

    savePractice() {
        const orgId = this.props.match.params.organizationId;
        this.setState({ errorMessage: null, isbusy: true }, () => {
            const validationErrors = this.validateForm();
            if (validationErrors) {
                this.setState({
                    isbusy: false,
                    errorMessage: validationErrors,
                });
            } else {
                // create new practice
                const attrs = {
                    name: this.state.name,
                    primary_practice: this.state.primary_practice,
                    abbreviation: this.state.abbreviation || '',
                };
                PracticeApi.create(orgId, attrs)
                    .then(() => {
                        this.setState({ isbusy: false });
                        // go back to the manage organizations page
                        history.push(`/organization/${orgId}/practices`);
                    })
                    .catch(errorMessage => {
                        this.setState({
                            isbusy: false,
                            errorMessage: errorMessage,
                        });
                    });
            }
        });
    }

    render() {
        const orgId = this.props.match.params.organizationId;
        return (
            <div className="page">
                <div className="page__subnav">
                    <Subnav organizationId={orgId} />
                </div>
                <div className="page__body">
                    <h2>Add a New Practice</h2>
                    <p className="lead">Add a practice to this organization by filling in the information below.</p>

                    <div className="form__field">
                        <label htmlFor="name">Name</label>
                        <input type="text" name="name" value={this.state.name} onChange={this.onChange} />
                    </div>
                    <div className="form__checkbox">
                        <input
                            id="isPrimaryPractice"
                            name="isPrimaryPractice"
                            type="checkbox"
                            checked={this.state.primary_practice}
                            onChange={() => {
                                this.setState({
                                    primary_practice: !this.state.primary_practice,
                                });
                            }}
                        />
                        <label htmlFor="isPrimaryPractice">Primary Practice</label>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="form__field">
                                <label htmlFor="name">Abbreviation</label>
                                <input type="text" name="abbreviation" value={this.state.abbreviation} onChange={this.onChange} />
                            </div>
                        </div>
                    </div>

                    <div className="form__footer">
                        <Message error={this.state.errorMessage} />
                    </div>

                    <div className="form__buttons">
                        <Button icon="fa-save" defaultText="Create Practice" busyText="Creating Practice..." isbusy={this.state.isbusy} onClick={this.savePractice} />
                        <Link to={`/organization/${orgId}/practices`}>Cancel</Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default withEhsPageBehavior(NewOrganizationPage);
